export const DEFAULT_DEV_FACTORS = [2.0, 1.85, 1.45, 1.25, 1.15, 1.05, 1.0];
export const DEFAULT_INCLUDE = [true, true, true, true, true, true, true];
export const DEFAULT_YEAR_COUNT = 7;
// Mirrors config.DEFAULT_TARGET_LOSS_RATIO in the united_es_loss_v1 engine,
// which applies the same default when the submission leaves it unset.
export const DEFAULT_TARGET_LOSS_RATIO = 0.55;
